<template>
  <div>
    <v-menu v-model="menuActive" :close-on-content-click="true">
      <template #activator="{ on }">
        <v-btn v-on="on" :disabled="!!changes.find(({ action, field, prev }) => action === 'change' && field === 'major' && prev === major)">
          <v-icon left>fal fa-exchange</v-icon>
          Change
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="$emit('major')">
          <v-list-item-title>Change Major</v-list-item-title>
        </v-list-item>
        <v-list-item :disabled="availableAdvisors.filter(({value}) => !currentAdvisors.find(({ value: v }) => v === value)).length === 0" @click="$emit('advisor')">
          <v-list-item-content>
            <v-list-item-title>Request Advisor Change</v-list-item-title>
            <v-list-item-subtitle v-if="availableAdvisors.filter(({value}) => !currentAdvisors.find(({ value: v }) => v === value)).length === 0">No other advisors available</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :disabled="!!changes.find(({ major: m, field }) => major === m && ['major', 'concentration'].includes(field))" @click="concDialog = true">
          <v-list-item-title>Change Concentrations</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <conc-dialog v-if="availableConcentrations.length > 0" v-model="concDialog" :major="major" :current-concentrations="currentConcentrations" :primary-concentrations="primaryConcentrations" @save="(c) => $emit('concentration', c)" />
  </div>
</template>
<script>
import { ref } from '@vue/composition-api'

export default {
  props: {
    major: {
      type: String,
      required: true
    },
    availableAdvisors: {
      type: Array,
      required: true
    },
    currentAdvisors: {
      type: Array,
      required: true
    },
    availableConcentrations: {
      type: Array,
      required: true
    },
    currentConcentrations: {
      type: Array,
      required: true
    },
    primaryConcentrations: {
      type: Array,
      required: true
    },
    changes: {
      type: Array,
      required: true
    }
  },
  components: {
    ConcDialog: () => import('@/components/student/program-change/conc-dialog')
  },
  setup () {
    const menuActive = ref(false)
    const concDialog = ref(false)

    function openConcDialog () {
      concDialog.value = true
      // menuActive.value = false
    }

    return {
      menuActive,
      concDialog,
      openConcDialog
    }
  }
}
</script>
